import { inject, signal, Signal } from '@angular/core';
import { injectQuery } from '@tanstack/angular-query-experimental';
import { environment } from 'src/environments/environment';

import { GqlService } from '@shared/services/gql.service';
import { MainQuery } from '@shared/store/main/main.query';
import { gqlToPromise } from '@shared/utils/gql-to-promise';

export const injectListIdOrganizationsQuery = ({
  includeInactive = signal(false),
}: {
  includeInactive?: Signal<boolean>;
} = {}) => {
  const gqlService = inject(GqlService);
  const mainQuery = inject(MainQuery);

  return injectQuery(() => ({
    queryFn: () => {
      if (environment.usePlayground) {
        return import('./list-id-organizations-query.mock').then(
          (m) => m.listIdOrganizationsQueryMock.fullList
        );
      }

      return gqlToPromise(() => {
        return gqlService.listIdOrganizations$(includeInactive());
      });
    },
    queryKey: ['trials', 'detail', mainQuery.trialKey(), 'list-id-organizations'],
  }));
};
